import { requests } from 'api';
import { Population } from './types';

const apiBaseUrl = '/api/populations';

export const PopulationsApi = {
  getAll: (): Promise<Population[]> => requests.get(apiBaseUrl),
};
